var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1","height":"64","fill":"none"}},[_c('path',{attrs:{"fill":"#EBEBEB","d":"M0 0h1v64H0z"}})])
}
var staticRenderFns = []

export default { render: render }